/**
 * @return {number} - 30000 (30 sec default value)
 */
export const getVmUpdateInterval = (refreshTimerValue) => (refreshTimerValue > 0 ? refreshTimerValue * 1000 : 0);
